import models from "models";

export const getSendMethodType = (contactType: models.UserContactType) =>
  contactType === "employees" ? models.SendMethodType.mobile : models.SendMethodType.email;

export const getFullNameOf = (user: models.User) => [user.first_name, user.last_name].filter((_) => _).join(" ");
